import ReactDOM from 'react-dom/client';
import { RouterProvider, createBrowserRouter, useRouteError, Outlet, useLocation } from 'react-router-dom';
import { Header } from 'react-frontier';
import { initReactI18next, useTranslation } from 'react-i18next';
import resourcesToBackend from "i18next-resources-to-backend";
import i18n from 'i18next';
import Login from './Login';
import 'frontier-css/css/frontier.css';

i18n.use(initReactI18next).use(resourcesToBackend(async (l: string)=>{
	var lang = (await import(`./locale/auth.${l}.json`)).default;
	return lang;
})).init({
	fallbackLng: 'es',
	interpolation: {
		escapeValue: false,
	}
});

var ErrorElement = ()=>{
	const error = (useRouteError() as any);
	return <Header
		text={error.status}
		subtext={error.status===404 ? 'Página no encontrada' : `Hubo un error inesperado. (PBL-LCL-${error.status})`}
		style={{ fontSize: 100 }}
		subheaderStyle={{ fontSize: 20 }}
		containerStyle={{ marginTop: 20 }}
	/>
}

var SiteContainer = (props: { outlet: JSX.Element })=>{
	var { t } = useTranslation();
	return <div style={{ paddingBottom: 50 }}>
		{props.outlet}
	</div>
}

const Router = createBrowserRouter([{
	path: '/',
	errorElement: <SiteContainer outlet={<ErrorElement />} />,
	element: <SiteContainer outlet={<Outlet />} />,
	children: [
		{ path: '/', element: <Login /> },
	]
}]);

var Root = ()=>{
	return <RouterProvider router={Router} />
}

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(<Root />);